"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReliabilityDetails = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _Builder = require("./inner/Builder");
var _Header = require("./inner/Header");
var _Content = require("../Layout/Content");
var _HousesStatistic = require("./inner/HousesStatistic");
var _CompletedHouses = require("./inner/CompletedHouses");
var _ConstructionProgress = require("./inner/ConstructionProgress");
var _Row = require("../Grid/Row");
var _Cell = require("../Grid/Cell");
var _ConstructionProgressStub = require("./inner/ConstructionProgressStub");
var _Houses = require("../Houses");
var _HousesMobile = require("../HousesMobile");
var _useReliabilityDetailsInformation = require("../../hooks/useReliabilityDetailsInformation");
var _LoadingScreen = require("../LoadingScreen");
var _Error = require("../Error");
var _ProblemBanner = require("./inner/ProblemBanner");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ReliabilityDetails = _ref => {
  let {
    open,
    onClose,
    newbuildingId,
    houseId,
    onEscrowIconClick
  } = _ref;
  const {
    isLoading,
    reliabilityDetails,
    loadReliabilityDetails
  } = (0, _useReliabilityDetailsInformation.useReliabilityDetailsInformation)({
    newbuildingId,
    houseId
  });
  const retry = React.useCallback(() => {
    loadReliabilityDetails({
      newbuildingId,
      houseId
    });
  }, []);
  if (isLoading || !reliabilityDetails) {
    return /*#__PURE__*/React.createElement(_LoadingScreen.LoadingScreen, null);
  }
  if (!reliabilityDetails) {
    return /*#__PURE__*/React.createElement(_Error.Error, {
      retry: retry
    });
  }
  const {
    checkDate,
    developers,
    constructionProgress,
    houses,
    checkStatus
  } = reliabilityDetails;
  return /*#__PURE__*/React.createElement(_uiKit.ModalWindow, {
    header: /*#__PURE__*/React.createElement(_Header.Header, {
      checkDate: checkDate
    }),
    open: open,
    width: 880,
    maxWidth: 880,
    onClose: onClose,
    fixed: true,
    content: /*#__PURE__*/React.createElement(_Content.Content, null, checkStatus && /*#__PURE__*/React.createElement(_Cell.Cell, null, /*#__PURE__*/React.createElement(_ProblemBanner.ProblemBanner, {
      title: checkStatus.title,
      description: checkStatus.description
    }), ' '), /*#__PURE__*/React.createElement(_Row.Row, null, /*#__PURE__*/React.createElement(_Cell.Cell, null, developers.map(developer => /*#__PURE__*/React.createElement(_Builder.Builder, {
      title: developer.type,
      avatar: developer.avatar,
      name: developer.name,
      key: developer.name,
      housesStatistic: developer.reliability ? /*#__PURE__*/React.createElement(_HousesStatistic.HousesStatistic, {
        housesDeadlineText: developer.reliability.housesDeadlineText,
        deadlineViolationsPercent: developer.reliability.deadlineViolationsPercent,
        completedHouses: /*#__PURE__*/React.createElement(_CompletedHouses.CompletedHouses, {
          completedHouses: developer.reliability.completedHouses
        })
      }) : null
    }))), /*#__PURE__*/React.createElement(_Cell.Cell, null, constructionProgress ? /*#__PURE__*/React.createElement(_ConstructionProgress.ConstructionProgress, {
      photo: constructionProgress.photos.slice(0, 4),
      status: constructionProgress.status,
      url: constructionProgress.url
    }) : /*#__PURE__*/React.createElement(_ConstructionProgressStub.ConstructionProgressStub, null))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, /*#__PURE__*/React.createElement(_HousesMobile.HousesMobile, {
      onEscrowIconClick: onEscrowIconClick,
      houses: houses
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      tablet: true,
      desktop: true
    }, /*#__PURE__*/React.createElement(_Houses.Houses, {
      onEscrowIconClick: onEscrowIconClick,
      houses: houses
    })))
  });
};
exports.ReliabilityDetails = ReliabilityDetails;